<template lang="html">
  <div class="ai-input-wrapper">
    <textarea v-if="type === 'textarea'"
              ref="textarea"
              class="ai-input ai-input--textarea"
              :class="{'ai-input--warning': pattern ===' warning'}"
              :value="value"
              :placeholder="placeholder"
              @input="onInputValueChange" />
    <input v-else
           ref="input"
           class="ai-input"
           :class="{'ai-input--warning': pattern === 'warning'}"
           :value="value"
           :type="type"
           :placeholder="placeholder"
           @input="onInputValueChange">
  </div>
</template>

<script>
export default {
  name: 'AiInput',
  props: {
    value: {
      type: [String, Number],
      default: ''
    },
    type: {
      type: String,
      default: 'text'
    },
    pattern: {
      type: String,
      default: 'default'
    },
    placeholder: {
      type: String,
      default: ''
    }
  },
  data: () => ({}),
  mounted() {},
  methods: {
    onInputValueChange({ target: { value } }) {
      if (this.type === 'number') {
        if (Number.isNaN(Number(value))) return;
        this.$emit('input', Number(value));
      } else {
        this.$emit('input', value);
      }
    }
  }
};
</script>
